export const placesZoomLevel = 15;
export const defaultLat = 40.7031;
export const defaultLng = -73.9712;
export const displayMoreInfo = true;
export const displaySearch = true;
export const defaultZoomLevel = 8;
